import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { DNDAssetGalleryCardDragPreview } from "~/components/DndAssetDragPreview";
import { DNDBoardGalleryCardDragPreview } from "~/components/DndBoardDragPreview";
import { DndDragPreviewContainer } from "~/components/DndDragPreviewContainer";
import { DNDFileGalleryCardDragPreview } from "~/components/DNDFileGalleryCardDragPreview";
import { DndItemType } from "~/types/DndKit";
/**
 * This component should later match GalleryItemsDragPreview
 * Just add `mixedTypes` and `count` accordingly
 */ export const KanbanItemsDragPreview = (param)=>{
    let { itemData } = param;
    const renderContent = useCallback(()=>{
        const data = itemData.apiData.data;
        switch(itemData.dndType){
            case DndItemType.kanbanBoard:
                return /*#__PURE__*/ _jsx(DNDBoardGalleryCardDragPreview, {
                    board: data
                });
            case DndItemType.kanbanAsset:
                return /*#__PURE__*/ _jsx(DNDAssetGalleryCardDragPreview, {
                    asset: data
                });
            case DndItemType.kanbanFile:
                return /*#__PURE__*/ _jsx(DNDFileGalleryCardDragPreview, {
                    file: data
                });
        }
    }, [
        itemData
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "relative",
        children: /*#__PURE__*/ _jsx(DndDragPreviewContainer, {
            className: "absolute left-0 top-0 flex",
            children: renderContent()
        })
    });
};
